// components/CustomAlert.tsx
import React from "react";
import { Alert, Snackbar } from "@mui/material";

interface CustomAlertProps {
  open: boolean;
  onClose: () => void;
  message: React.ReactNode;
  severity?: "error" | "warning" | "info" | "success";
  duration?: number;
}

const CustomAlert: React.FC<CustomAlertProps> = ({
  open,
  onClose,
  message,
  severity = "info",
  duration = 6000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{ maxWidth: { xs: "100%", sm: 520 }, width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomAlert;